import { twMerge } from 'tailwind-merge';

export type FormType = 'signin' | 'signup';

interface Props {
  className?: string;
  type: FormType;
  onChange?(type: FormType): void;
}

export function FormTypeSwitch(props: Props) {
  const isSignIn = props.type === 'signin';
  const linkText = isSignIn ? 'Sign Up' : 'Log in';
  const promptText = isSignIn ? "Don't have an account?" : 'Have an account?';
  const targetType: FormType = isSignIn ? 'signup' : 'signin';

  return (
    <div className={twMerge('text-white', 'text-xs', props.className)}>
      {promptText}{' '}
      <button
        type="button"
        className="underline"
        onClick={() => {
          props.onChange?.(targetType);
        }}
      >
        {linkText}
      </button>
    </div>
  );
}
